import { View } from 'backbone';
import template  from 'designer/modals/mobile-design-information-modal.ejs';

class MobileDesignInformationModal extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.El = "#mobileDesignInformationModal";

        return this;
    }

    closeModal() {
        $(this.El).remove();
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            $('body').append(this.$el);

            let self = this;

            this.dialog = $(self.El).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 370,
                width: 500,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        'class':'btn-select-field',
                        click: () => {
                            this.dialog.dialog( "close" );
                            resolve('OK');
                        }
                    }
                ],
                close: () => {
                    this.dialog.dialog("destroy");
                    this.closeModal();
                },
                open: () =>{
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
            this.delegateEvents();
            return this;
        });
    }
}

export default MobileDesignInformationModal;
